#!/usr/bin/env node

import { shouldCreatePR } from './pull-client.js';

const shouldCreate = await shouldCreatePR();
console.log(shouldCreate);
